<template>
  <div class="storeServe">
    <div class="banner">
      <p>水疗养生/休闲娱乐/会所店铺经营管理平台</p>
    </div>
    <img class="serveSize" src="../assets/image/storeServe/serveSize.png" alt />
    <div class="commission">
      <h1 class="flex_center">
        <b></b>
        <i>行业最低抽佣</i>
        <b></b>
      </h1>
      <div class="box">
        <div class="line flex_center">
          <div class="img">
            <img src="../assets/image/storeServe/commission1.png" alt />
            <p>
              抽
              <i>30%</i>
            </p>
          </div>
          <div class="right">
            <p>某平台</p>
            <p>抽拥30%</p>
          </div>
        </div>
        <div class="line flex_center">
          <div class="img">
            <img src="../assets/image/storeServe/commission2.png" alt />
            <p class="p1">商家获利</p>
            <p class="p2">最低抽佣</p>
          </div>
          <div class="right">
            <p>按个摩平台</p>
            <p>行业最低抽佣，商家利润提升</p>
          </div>
        </div>
      </div>
    </div>
    <div class="serveItem">
      <h1 class="flex_center">
        <b></b>
        <i>多种服务场景</i>
        <b></b>
      </h1>
      <div class="box flex_sw">
        <div class="item">
          <img src="../assets/image/storeServe/serveItem1.png" alt />
          <p>用户本地订单</p>
        </div>
        <div class="item">
          <img src="../assets/image/storeServe/serveItem2.png" alt />
          <p>异地差旅订单</p>
        </div>
      </div>
    </div>
    <div class="serveItem">
      <h1 class="flex_center">
        <b></b>
        <i>两种模式可选择</i>
        <b></b>
      </h1>
      <div class="box flex_sw">
        <div class="item">
          <img src="../assets/image/storeServe/serveItem3.png" alt />
          <p>上门服务</p>
        </div>
        <div class="item">
          <img src="../assets/image/storeServe/serveItem4.png" alt />
          <p>到店服务</p>
        </div>
      </div>
    </div>

    <div class="operation">
      <h1 class="flex_center">
        <b></b>
        <i>合作流程</i>
        <b></b>
      </h1>
      <div class="list flex_sw">
        <div class="item">
          <img src="../assets/image/storeServe/operation1.png" alt />
          <h6>1.提交资质</h6>
        </div>
        <div class="item">
          <img src="../assets/image/storeServe/operation2.png" alt />
          <h6>2.需求沟通</h6>
        </div>
        <div class="item">
          <img src="../assets/image/storeServe/operation3.png" alt />
          <h6>3.合同签订</h6>
        </div>
        <div class="item">
          <img src="../assets/image/storeServe/operation4.png" alt />
          <h6>4.上线使用</h6>
        </div>

        <div class="arrow flex_center">
          <i></i>
          <i></i>
          <i></i>
        </div>
      </div>
    </div>
    <div class="btn flex_center">
      <a href="https://jinshuju.net/f/NwS01f">立即开店</a>
    </div>
    <!-- <div class="footer">
      <h6>商户入驻</h6>
      <img src="../assets/image/storeSpreadPage/icon_wechat_code.jpg" alt />
      <button class="btn" data-clipboard-text="15728712661">复制微信号</button>
      <p>联系电话：157-2871-2661</p>
      <p>周一 至 周日 9:00 至 22:00</p>
    </div>-->
  </div>
</template>
<script>
import ClipboardJS from "clipboard";
export default {
  mounted() {
    var self = this;
    var clipboard = new ClipboardJS(".btn");
    clipboard.on("success", function (e) {
      self.$alert({
        text: "复制成功",
      });
      e.clearSelection();
    });
  },
  methods: {
    clipboardData() {
      window.clipboardData.setData("Text", "15728712661");
    },
  },
};
</script>
<style lang="scss" scoped>
@import url("../assets/style/rem.css");
.storeServe {
  position: relative;
  .banner {
    width: 100%;
    height: 3.69rem;
    background: url("../assets/image/storeServe/banner.png") no-repeat;
    background-size: 100% auto;
    color: #fff;

    p {
      position: absolute;
      left: 0.4rem;
      top: 1.56rem;
      height: 0.42rem;
      border-radius: 0.1rem;
      border: 1px solid rgba(255, 255, 255, 1);
      padding: 0 0.1rem;
      line-height: 0.42rem;
      box-sizing: border-box;
      font-size: 0.24rem;
    }
  }

  .serveSize {
    width: 6.9rem;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 0.1rem 0px rgba(51, 51, 51, 0.2);
    border-radius: 0.2rem;
    margin: 0.3rem auto;
    display: block;
  }

  h1 {
    color: #666666;
    font-size: 0.3rem;
    padding: 0.24rem 0 0.34rem;

    b {
      display: block;
      width: 0.5rem;
      height: 0.04rem;
      background: url("../assets/image/storeServe/line.png") no-repeat;
      background-size: 100% auto;

      &:nth-child(1) {
        transform: rotate(180deg);
      }
    }
    i {
      margin: 0 0.14rem;
    }
  }

  .commission {
    width: 6.9rem;
    height: 5rem;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 0.1rem 0px rgba(51, 51, 51, 0.2);
    border-radius: 0.2rem;
    box-sizing: border-box;
    padding: 0 0.2rem;
    margin: auto;

    .line {
      width: 6.5rem;
      height: 1.68rem;
      background: rgba(251, 248, 255, 1);
      border-radius: 0.2rem;
      margin-bottom: 0.3rem;

      .img {
        position: relative;
        p {
          position: absolute;
        }
      }

      &:nth-child(1) {
        img {
          width: 2.26rem;
        }

        .img {
          p {
            color: #f69e1c;
            left: 0.87rem;
            top: 0.33rem;
            font-size: 0.2rem;

            i {
              font-size: 0.24rem;
            }
          }
        }
      }
      &:nth-child(2) {
        img {
          width: 2.32rem;
        }

        .img {
          .p1 {
            color: #6dd400;
            font-size: 0.22rem;
            transform: rotate(-12deg);
            top: 0.4rem;
            left: 0.66rem;
          }

          .p2 {
            color: #f69e1c;
            font-size: 0.22rem;
            left: 0.74rem;
            top: 1.08rem;
          }
        }
      }

      .right {
        margin-left: 0.88rem;
        width: 2.75rem;
        p {
          color: #666666;
          font-size: 0.28rem;
          &:nth-child(2) {
            color: #999999;
            font-size: 0.26rem;
            margin-top: 0.11rem;

            b {
              color: #897af2;
            }
          }
        }
      }
    }
  }

  .serveItem {
    padding: 0 0.3rem;
    h1 {
      padding: 0.3rem 0 0.24rem;
    }

    .item {
      width: 3.4rem;
      height: 2.38rem;
      border-radius: 0.2rem;
      position: relative;
      overflow: hidden;
      img {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: -1;
      }

      p {
        width: 100%;
        height: 100%;
        background: rgba(51, 51, 51, 0.3);
        color: #fff;
        line-height: 2.38rem;
        text-align: center;
        font-size: 0.3rem;
      }
    }
  }

  .operation {
    padding-bottom: 2.5rem;
    h1 {
      padding: 0.5rem 0 0.4rem;
    }
    .list {
      padding: 0 0.3rem;
      position: relative;

      .item {
        text-align: center;

        img {
          width: 1.2rem;
          height: 1.2rem;
          margin-bottom: 0.1rem;
        }

        h6 {
          color: #666666;
          font-size: 0.28rem;
          font-weight: normal;
        }
      }

      .arrow {
        position: absolute;
        left: 0;
        top: 0.48rem;
        width: 100%;

        i {
          display: block;
          width: 0.22rem;
          height: 0.25rem;
          background: url("../assets/image/storeServe/arrow.png") no-repeat
            center center;
          background-size: 100% auto;
          margin-right: 1.68rem;

          &:last-child {
            margin: 0;
          }
        }
      }
    }
  }

  .footer {
    text-align: center;
    position: relative;
    overflow: hidden;
    h6 {
      color: #333333;
      font-size: 0.3rem;
      padding: 0.58rem 0 0.18rem;
    }

    img {
      width: 2rem;
      height: 2rem;
      margin: auto;
      display: block;
      box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.18);
      border-radius: 0.05rem;
    }

    button {
      width: 1.6rem;
      height: 0.6rem;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2);
      border-radius: 0.3rem;
      color: #897af2;
      font-size: 0.26rem;
      line-height: 0.6rem;
      margin: 0.14rem auto 0.18rem;
      cursor: pointer;
      padding: 0;
    }

    p {
      color: #666666;
      font-size: 0.28rem;
      margin-bottom: 0.1rem;

      &:last-child {
        margin-bottom: 0.78rem;
      }
    }
  }
  .btn {
    width: 100%;
    background: #fff;
    position: fixed;
    left: 0;
    bottom: 0;
    padding: 0.2rem 0;

    a {
      display: block;
      width: 6.1rem;
      height: 0.88rem;
      text-align: center;
      background: linear-gradient(
        270deg,
        rgba(120, 147, 239, 1) 0%,
        rgba(157, 110, 247, 1) 100%
      );
      border-radius: 0.56rem;
      line-height: 0.88rem;
      color: #fff;
      font-size: 0.32rem;
    }
  }
  &::after {
    display: block;
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 2.1rem;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 1) 0%,
      rgba(212, 211, 255, 1) 100%,
      rgba(127, 112, 239, 1) 100%
    );
    z-index: -1;
  }
}
//iphoneX、iphoneXs
@media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
  .btn {
    padding-bottom: 0.68rem !important;
  }
}
//iphone Xs Max
@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) {
  .btn {
    padding-bottom: 0.68rem !important;
  }
}

//iphone XR
@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) {
  .btn {
    padding-bottom: 0.68rem !important;
  }
}
</style>